import {
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Stack,
  Typography,
} from '@mui/material';
import React, { useState } from 'react';
import { OrderType } from '../../../../interfaces/delivery-company/orders';
import { get_cod } from '../../../../utils/cod';
import { Money } from '../../../../utils/money';
import CustomDialog from '../../../common/custom-dialog/custom-dialog';
import MoneyInput from '../../../common/money-input/money-input';
import { LabelValue } from '../../../../interfaces/delivery-company/labels';

interface UpdateExtraDeliveryChargeProps {
  onSubmit: (m: Money[]) => void;
  onClose: () => void;
  labelValue: LabelValue;
}

function UpdateExtraDeliveryCharge({
  onSubmit,
  onClose,
  labelValue,
}: UpdateExtraDeliveryChargeProps) {
  const [extraDeliveryCharge, setExtraDeliveryCharge] = useState<Money[]>(
    labelValue.extra_delivery_fee
  );

  const handleSubmit = () => {
    onSubmit(extraDeliveryCharge);
    onClose();
  };

  return (
    <CustomDialog open={true} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        Extra Delivery For Option: <b>{labelValue.value}</b>
      </DialogTitle>
      <DialogContent>
        <br />
        <MoneyInput
          money={extraDeliveryCharge}
          setMoney={setExtraDeliveryCharge}
          label="Extra Delivery Fees"
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button variant="contained" onClick={handleSubmit}>
          Save
        </Button>
      </DialogActions>
    </CustomDialog>
  );
}

export default UpdateExtraDeliveryCharge;
